/**=========================================================
 * Module: app-grouper.js
 * Handles grouper
 =========================================================*/

 App.directive('appGrouper', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/grouper.html',
        restrict: 'E',
        replace: true,
        controller: 'GrouperController',
        scope: { 
            field: '=field',
            model: '=model',
            form: '=form' 
        }
    };
  
  });
  